/**
 * Отрабатывает при смене таба с Взрослым на Детям и обратно
 * @param data
 * @param tabsForms
 * @param setDropdownItemsEvent
 */
export default function fillDoctors(data, tabsForms, setDropdownItemsEvent) {
  let doctorsSelectItems = '';
  Object.entries(data.data).forEach(([key, value]) => {
    doctorsSelectItems += `  <div data-doctid="${value}" class="body-item">
                                            ${key}
                                        </div>`;
  });
  tabsForms.forEach((tabsForm) => {
    const thisDropdownHead = tabsForm.querySelector('.doctors-select .dropdown-head');
    const selectHead = thisDropdownHead.querySelector('.head-text');
    selectHead.innerText = 'Любой врач';
    selectHead.dataset.doctid = '-1';
    const doctorsSelectBody = tabsForm.querySelector('.doctors-select .dropdown-body');
    doctorsSelectBody.innerHTML = doctorsSelectItems;
    setDropdownItemsEvent(doctorsSelectBody.querySelectorAll('.body-item'));
  });
}
